import React, { useState } from "react";
import { Row, Col } from "reactstrap";
import Searchbar from "pages/utils/search_bar";
import { SelectField } from "pages/InputFields/InputFields";
import Drawer from 'react-modern-drawer';
import 'react-modern-drawer/dist/index.css';

const FilterBar = ({ searchTerm, setSearchTerm, filterType, setFilterType, filterStatus, setFilterStatus }) => {
    const [drawerOpen, setDrawerOpen] = useState(false);

    const toggleRightDrawer = () => setDrawerOpen((prev) => !prev);

    return (
        <>
            <Row className="mb-4 align-items-center">
                <Col md="3" sm="6">
                    <Searchbar handleSearch={setSearchTerm} />
                </Col>
                <Col xs="auto" className="d-flex align-items-center">
                    <button
                        className="btn btn-white d-flex align-items-center rounded-3 bg-white"
                        onClick={toggleRightDrawer}
                        style={{
                            height: "38px",
                            border: "1px solid #ced4da",
                            padding: "0 15px",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
                            transition: "all 0.2s ease"
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.boxShadow = "0 4px 8px rgba(0,0,0,0.06)";
                            e.currentTarget.style.borderColor = "#adb5bd";
                            e.currentTarget.style.transform = "translateY(-1px)";
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.boxShadow = "0 2px 4px rgba(0,0,0,0.02)";
                            e.currentTarget.style.borderColor = "#ced4da";
                            e.currentTarget.style.transform = "translateY(0px)";
                        }}
                    >
                        <i className="bx bx-filter-alt me-2 text-primary" style={{ fontSize: "18px" }}></i>
                        <span className="text-secondary fw-semibold">Filter</span>
                    </button>
                </Col>
            </Row>

            <Drawer open={drawerOpen} onClose={toggleRightDrawer} direction='right' size={420}>
                <div className="d-flex flex-column vh-100">
                    {/* Header */}
                    <div className="p-3 d-flex justify-content-between align-items-center border-bottom bg-white">
                        <h4 className="fw-bolder mb-0"> Filter </h4>
                        <button onClick={() => setDrawerOpen(false)}
                            className="btn p-0 d-flex align-items-center justify-content-center"
                            style={{
                                backgroundColor: "#ff0d00", width: "20px", height: "20px",
                                borderRadius: "50%", border: "none", boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                            }}
                        >
                            <i className="bx bx-x text-white" style={{ fontSize: "18px" }}></i>
                        </button>
                    </div>
                    {/* Body */}
                    <div className="p-4 flex-grow-1 overflow-auto">
                        <div className="mb-4">
                            <SelectField
                                label="Type"
                                name="type"
                                isClearable={true}
                                value={filterType}
                                onChange={setFilterType}
                                placeholder="Select Type..."
                                options={[
                                    { value: "Client", label: "Client" },
                                    { value: "Customer", label: "Customer" },
                                    { value: "Admin", label: "Admin" },
                                    { value: "User", label: "User" },
                                ]}
                            />
                        </div>

                        <div className="mb-4">
                            <SelectField
                                label="Current Status"
                                name="status"
                                isClearable={true}
                                value={filterStatus}
                                onChange={setFilterStatus}
                                placeholder="Select Status..."
                                options={[
                                    { value: "Active", label: "Active" },
                                    { value: "Inactive", label: "Inactive" },
                                    { value: "Pending", label: "Pending" },
                                ]}
                            />
                        </div>
                    </div>

                    {/* Footer */}
                    <div className="p-4 bg-white shadow-sm border-top d-flex gap-3 mt-auto">
                        <button
                            className="btn btn-outline-secondary flex-grow-1 fw-semibold py-2 rounded-3"
                            onClick={() => {
                                setFilterType(null);
                                setFilterStatus(null);
                                setDrawerOpen(false);
                            }}
                        >
                            Reset
                        </button>
                        <button
                            className="btn btn-primary flex-grow-1 fw-bold py-2 rounded-3 shadow-sm d-flex justify-content-center align-items-center gap-2"
                            onClick={() => setDrawerOpen(false)}
                        >
                            <span>Apply Filters</span>
                            <i className="bx bx-right-arrow-alt fs-5"></i>
                        </button>
                    </div>

                </div>
            </Drawer>
        </>
    );
};

export default FilterBar;